<div class="container {{ arrowOrientation }}" [ngClass]="{'text-blur': blur}" [ngStyle]="{ 'font-size': fontSize }">
  <div class="container-arrow" *ngIf="!blur"></div>
  <div class="container-content">{{ content * 100 | number: '.0-1' }}%</div>
</div>
